import { tr } from "date-fns/locale";
import React, { useState } from "react";
import { updateUser } from "../../helper/userHelper";
import { useAuthContext } from "../../hooks/useAuthContext";
import { DeviceCalibrationProps } from "../../interfaces";

const EcCalibrationForm = ({device}:DeviceCalibrationProps) => {
    const { user } = useAuthContext();
    const [beginState, setBeginState] = useState(false)
    const [stepOneState, setStepOneState] = useState(false)
    const [stepTwoState, setStepTwoState] = useState(false)
    const [stepThreeState, setStepThreeState] = useState(false)
    

    const dryCalibration = async() => {
        if(user){
            user.calibrate_device = true
            user.device_to_calibrate = device.device_id
            user.calibration_outgoing_message = "Dry"
            const response = await updateUser(user);
            if(response.ok){
                let counter = 0;
                const intervalId = setInterval(async function() {
                counter++;
                
                const response = await updateUser(user);
                let user_calibration_data = await response.json()
                if(user_calibration_data.calibration_incoming_message === 'Ok'){
                    setStepOneState(true)
                }
                if (counter === 5*(60)) {
                    clearInterval(intervalId);
                }
                }, 2000);
            }
        }
    }


    return ( 
        <>
        <div style={{
            'display': 'block'
        }}>
        
        <h3>Calibrating {device.device_type} </h3>
        <p>The calibration process is a 3 step procedure. First we perform a dry calibration with the sensor,
            then the low point (12,880 µS), then lastly the high point (80000 µS). It's important to follow this order in order to successfully
            calibrate the sensor.
        </p>
        <button onClick={(e) => {
            e.preventDefault();
            setBeginState(!beginState)
        }}>Begin</button>
        <br />
        {(beginState && !stepOneState && !stepTwoState && !stepThreeState) && 
        <>
        <label>Step 1: Dry Calibration</label>
        <ol>
            <li>Make sure the probe is dry</li>
            <li>Press to start dry calibration<button>Start</button></li>
            <li>Wait for reading to say "Calibrated Dry" before moving onto the next step.</li>
        </ol>        
        <label>Reading:</label> value
        </>
        }
        
       <br/>
       {(stepOneState && !beginState && !stepTwoState && !stepThreeState) && 
       <>
 <label>Step 2: Low-Point Calibration</label>
        <ol>
            <li>Pour some of the 12880µS calibration solution into a cup. Make sure the solution covers the sensor area at the bottom of the probe.</li>
            <li>Place the probe into the cup ans stir it around to remove trapped air bubbles</li>
            <li>Let the probe sit in the solution and wait for the readings below to stabilize this should take around 1-2 minutes
                (the readings may have small movements from one reading to the next but this is normal).
                 Note: The value may look considerably off from the solution value, this is to be expected as the device 
                 isn't fully calibrated
            </li>
            <li>Remove the top of the pH 4 calibration solution pouch, then place the probe inside.</li>
            <li>Wait for reading to stabilize (1-2 minutes)</li>
            <li>Press the "Okay" button when readings stabilize</li>
            <li>Wait for the reading to say "Calibrated Low" before moving onto the next step.</li>
        </ol>
        <label>Reading</label> value
       </>
       }
       
        <br />

       {(stepTwoState && !beginState && !stepTwoState && !stepThreeState) && 
       <>
        <label>Step 3:</label>
        <ol>
            <li>Remove the probe from the previous solution and rinse it off with water. </li>
            <li>Gently shake the probe to remove excess water</li>
            <li>Pour some of the 80000µS calibration solution into a cup. Make sure the solution covers the sensor area at the bottom of the probe.</li>
            <li>Place the probe into the cup ans stir it around to remove trapped air bubbles</li>
            <li>Let the probe sit in the solution and wait for the readings below to stabilize this should take around 1-2 minutes
                (the readings may have small movements from one reading to the next but this is normal).
                 Note: The value may look considerably off from the solution value, this is to be expected as the device 
                 isn't fully calibrated
            </li>
            <li>Press the "Okay" button when readings stabilize</li>
            <li>Once the reading says "Calibrated High" your device if finally calibrated.</li>
        </ol>
        <label>Reading:</label>value

        
       </>}
        {stepThreeState && <>
        Calibrated Successfully!!!!
        </>}
        </div>
        </>
     );
}
 
export default EcCalibrationForm;